<template>
  <!--编辑画面-->
  <div>
    <!--    <iframe  v-bind:src="/byzt/index_edit.html?stageId=" style="border:0px;width:100%;height:800px"></iframe>-->
    <iframe class="editIframeZT" v-bind:src="'/static/byzt/index_edit.html?stageId='+stageId+'&token='+token"></iframe>
  </div>

</template>

<script setup>
// import { getToken } from '@/utils/auth'
import {useRouter} from "vue-router/dist/vue-router";
import {onMounted, ref} from "vue";

let router = useRouter()
// name: "hmbj",
// props: {
//   stageId: {
//     type: String
//   }
// }
let token = ref('')
let stageId = ref('')

onMounted(() => {
  // token.value=getToken();
  stageId.value = router.currentRoute.value.params.stageId
  console.log(router.currentRoute.value.params.stageId, 'aaaaaa')

})

</script>

<style lang="scss" scoped>
.editIframeZT {
  /* 50= navbar  50  */
  min-height: calc(100vh - 88px);
  width: 100%;
  border: 0px;
}
</style>
